// ============================================================================
// BRIDGES & ARTICULATION - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'bridges-articulation',
  name: 'Bridges & Articulation',
  category: 'Graphs',
  complexity: {
    time: 'O(V + E)',
    space: 'O(V)'
  },
  description: 'Algorithms to find bridges (edges whose removal disconnects the graph) and articulation points (vertices whose removal disconnects the graph). Uses DFS with discovery times and low values.'
};
